import type { CountryIso } from "~/types"

const canadaEligibleNationalities: CountryIso[] = [
  "AND",
  "AUS",
  "AUT",
  "BHS",
  "BRB",
  "BEL",
  "GBR",
  "AIA",
  "BMU",
  "VGB",
  "CYM",
  "FLK",
  "GIB",
  "MSR",
  "PCN",
  "SHN",
  "TCA",
  "BRN",
  "BGR",
  "CHL",
  "HRV",
  "CYP",
  "CZE",
  "DNK",
  "EST",
  "FIN",
  "FRA",
  "DEU",
  "GRC",
  "HKG",
  "HUN",
  "ISL",
  "IRL",
  "ISR",
  "ITA",
  "JPN",
  "KOR",
  "LVA",
  "LIE",
  "LTU",
  "LUX",
  "MLT",
  "MCO",
  "NLD",
  "NZL",
  "NOR",
  "PNG",
  "POL",
  "PRT",
  "ROU",
  "WSM",
  "SMR",
  "SGP",
  "SVK",
  "SVN",
  "SLB",
  "ESP",
  "SWE",
  "CHE",
  "TWN",
  "ARE",
  "VAT"
];

export default canadaEligibleNationalities;